<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>
  <!-- Form -->
  <form @submit.prevent="store" class="form-content" style="height: 90vh">
    <div class="form-content-inner">
      <control
        type="hidden"
        v-model="violationConsequencies.id"
        :hasError="!!errors.id"
        id="id"
      />

      <div class="form-col">
        <field
          :label="$t('violationConsequencies.sequenceNo')"
          class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
          :hasError="errors.sequence_no"
        >
          <control
            type="number"
            :placeholder="$t('violationConsequencies.placeholder.sequenceNo')"
            v-model="violationConsequencies.sequence_no"
            :hasError="!!errors.sequence_no"
            id="sequence_no"
          />
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('violationConsequencies.punishmentMaster')"
          class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
          :hasError="errors.punishment_master_id"
        >
          <control
            :options="punishmentMasterList"
            :placeholder="
              $t('violationConsequencies.placeholder.punishmentMaster')
            "
            v-model="violationConsequencies.punishment_master_id"
            id="punishment_master_id"
            :hasError="!!errors.punishment_master_id"
            @change="onChange(violationConsequencies, $event)"
          />
        </field>
        showExpireIn {{ showExpireIn }}
      </div>

      <div class="form-col" v-if="showExpireIn">
        <field
          :label="$t('violationConsequencies.expiredIn')"
          class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
          :hasError="errors.expired_in"
        >
          <control
            type="number"
            :placeholder="$t('violationConsequencies.placeholder.expiredIn')"
            v-model="violationConsequencies.expired_in"
            :hasError="!!errors.expired_in"
            id="expired_in"
          />
        </field>
      </div>

      <!-- <div class="form-col">
          <field
            :label="$t('violationConsequencies.violation')"
             class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
            :hasError="errors.violation_id"
          >
            <control
              :options="violationList"
              :placeholder="$t('violationConsequencies.placeholder.violation')"
              v-model="violationConsequencies.violation_id"
              id="violation_id"
              :hasError="!!errors.violation_id"
              @change="onChange(violationConsequencies, $event)"
            />
          </field>
        </div> -->

      <div
        class="buttons-submit transition-colors duration-1000"
        :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'"
      >
        <jb-buttons class="buttons-action-submit">
          <jb-button
            type="submit"
            color="info"
            :icon="mdiCheckBold"
            :label="$t('finance.button.btnSubmit')"
            class="form-submit-btn"
          />
          <jb-button
            type="button"
            color="info"
            outline
            :label="$t('finance.button.btnReset')"
            class="form-noicon-btn btn-reset"
            @click="reset()"
          />
        </jb-buttons>
      </div>
    </div>
  </form>
</template>
<script>
/* eslint-disable */
import {
  ref,
  reactive,
  onMounted,
  onBeforeMount,
  watch,
  watchEffect,
  computed,
} from "vue";
import axios from "axios";
import { mdiBallot, mdiCheckBold } from "@mdi/js";
import Control from "@/components/Control";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import JbButton from "@/components/JbButton";
import JbButtons from "@/components/JbButtons";
import Field from "@/components/Field";
import { useToast } from "vue-toastification";
//   import Datepicker from '@vuepic/vue-datepicker'
import "@vuepic/vue-datepicker/dist/main.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "ClassForm",
  components: {
    Field,
    Control,
    Loading,
    JbButton,
    JbButtons,
  },
  props: {
    showEdit: { Boolean },
    propClass: {
      type: Object,
      default: () => ({ empty: true }),
    },
    violationId: {
      type: String,
      default: "",
    },
    propDepartment: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propYear: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propLevel: {
      type: Object,
      default: () => ({ empty: true }),
    },
  },
  data: function () {
    return {};
  },
  emits: ["close-modal", "submit", "reset-modal"],
  setup(props, { emit }) {
    const titleStack = ref(["Admin", "Forms"]);

    const isLoading = ref(false);

    const toast = useToast();

    const router = useRouter();

    const errors = ref([]);

    const str = useStore();

    const userlogin = localStorage.getItem("name");

    const violationList = ref();
    const punishmentMasterList = ref();

    const showExpireIn = ref(false);

    const violationConsequencies = reactive({
      id: "",
      punishment_master_id: "",
      sequence_no: "",
      violation_id: "",
    });

    const reset = () => {
      // programmeOwner.programme_id = ''
      violationConsequencies.sequence_no = "";
      violationConsequencies.punishment_master_id = "";
    };

    const selected = ref([]);

    const store = async () => {
      isLoading.value = true;
      const url = props.showEdit
        ? "violation-consequencies/" + violationConsequencies.id
        : "violation-consequencies";
      const method = props.showEdit ? "PUT" : "POST";
      if (method === "POST") {
        violationConsequencies.created_by = userlogin;
        //   violationConsequencies.punishment_master_id = props.violationId.value;
      } else {
        violationConsequencies.updated_by = userlogin;
      }
      violationConsequencies.violation_id = props.violationId;
      console.log("props.violationId", props.violationId);
      const jsonData = JSON.stringify(violationConsequencies);
      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };
      await axios({
        method,
        url,
        data: jsonData,
        headers: configHeaders,
      })
        .then((response) => {
          if (response.data.success) {
            emit("reset-modal");
            emit("close-modal");
            toast.success(response.data.message);
          } else {
            errors.value = response.data.messages;
            toast.error(response.data.messages);
          }
          isLoading.value = false;
          reset();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error);
            toast.error(error.response.data.message);
            console.log(JSON.stringify(error.request));
          } else if (error.message) {
            console.log(error.message);
            toast.error(error.message);
            console.log(JSON.stringify(error.message));
          }
          isLoading.value = false;
        });
    };

    const getPunishmentMaster = async () => {
      isLoading.value = true;
      await axios
        .get("punishment-master")
        .then((response) => {
          punishmentMasterList.value = response.data.data;
          // filter.department_id = departmentList.value[0].id
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const getViolation = async () => {
      isLoading.value = true;
      await axios
        .get("violation")
        .then((response) => {
          violationList.value = response.data.data;
          // filter.department_id = departmentList.value[0].id
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    onBeforeMount(() => {});

    onMounted(() => {
      // academicyear.value =toRefs(props, 'propClass')
      getPunishmentMaster();
      getViolation();
    });

    watch(
      () => props.violationId,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          violationConsequencies.violation_id = newVal;
        }
      }
    );

    watchEffect(() => {
      const newviolationConsequencies = props.propClass;
      // holidaysList.value = props.propHolidays
      if (!props.showEdit) {
        newviolationConsequencies.id = null;
      }
      // if (props.propClass.is_active !== undefined) {
      //   customElementsForm.is_active = [props.propClass.is_active]
      // }
      Object.assign(violationConsequencies, newviolationConsequencies);
    });

    watch(
      () => violationConsequencies.punishment_master_id,
      (newVal) => {

        const matched = punishmentMasterList.value.find(
          (item) => item.id === newVal
        );
       

        if (matched && matched.active_expire_date === true) {
          showExpireIn.value = true;
        } else {
          showExpireIn.value = false;
        }
      }
    );
    
    return {
      isLoading,
      titleStack,
      violationConsequencies,
      violationList,
      punishmentMasterList,
      // customElementsForm,
      mdiBallot,
      mdiCheckBold,
      router,
      getPunishmentMaster,
      getViolation,
      store,
      toast,
      userlogin,
      errors,
      reset,
      str,
      selected,
      showExpireIn
    };
  },
  methods: {
    clearForm() {
      this.violationConsequencies = reactive({
        id: "",
        punishment_master_id: "",
        sequence_no: "",
        violation_id: "",
        created_by: "",
      });
    },
    onChange: function (programme_id, event) {
      if (event.target.value) {
        programme_id = event.target.value;
      }
    },
  },
  // created () {
  //   this.levelListFilter = this.levelList
  //   this.academicYearListFilter = this.academicYearList
  // }
};
</script>
